import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  generalIndicatorData: null,
  generalIndicatorCompetences: [],
  errorData: null,
  error: null,
  loading: null,
};

export function generalIndicator(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case types.GENERAL_INDICATORS_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GENERAL_INDICATORS_SUCCESS: {
        draft.generalIndicatorData = action.payload.generalIndicatorData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GENERAL_INDICATORS_FAILURE: {
        draft.errorData = action.payload.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       * GET COMPETENCIAS
       * ---------------------------------------------------
       */

      case types.GENERAL_COMPETENCES_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GENERAL_COMPETENCES_SUCCESS: {
        draft.generalIndicatorCompetences =
          action.payload.generalIndicatorCompetences;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GENERAL_COMPETENCES_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      default:
        return state;
    }
  });
}
